import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const recordsCadenceEffectivenessState = (state: RootState) =>
  state.scene.dashboard.recordsCadenceEffectivenessState;

export const getRecordsCadenceEffectivenessDrillDownViewState = createSelector(
  recordsCadenceEffectivenessState,
  ({ viewState }) => viewState
);

export const getRecordsCadenceEffectivenessDrillDownBand = createSelector(
  recordsCadenceEffectivenessState,
  ({ band }) => band
);

export const getRecordsCadenceEffectivenessDrillDownTotalFilteredRecords = createSelector(
  recordsCadenceEffectivenessState,
  ({ totalFilteredRecords }) => totalFilteredRecords
);

export const getRecordsCadenceEffectivenessDrillDownConfiguration = createSelector(
  recordsCadenceEffectivenessState,
  ({ configuration }) => configuration
);

export const isRecordsCadenceEffectivenessDrillDownLoading = createSelector(
  recordsCadenceEffectivenessState,
  ({ loading }) => loading
);
